<template>
    <b-form>
        <!--Producer INFO-->
        <div>
            <b-row>
                <b-col>
                    <h3 class="mb-1">Producer Information</h3>
                    <hr class="mb-5"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="First Name:" label-for="firstName">
                        <b-form-input
                                type="text"
                                v-model="enrollment.firstName">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Last Name:" label-for="lastName">
                        <b-form-input
                                type="text"
                                v-model="enrollment.lastName">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Email:" label-for="email">
                        <b-form-input type="email" v-model="enrollment.email"/>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Password:" label-for="workPhone">
                        <b-form-input type="password" v-model="enrollment.password"/>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Verify:" label-for="fax">
                        <b-form-input type="password" v-model="enrollment.verify"/>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>

        <!--ERRORS-->
        <b-row v-show="enrollment.errors.length" class="mt-5">
            <b-col md="12">
                <div class="alert alert-danger">
                    <strong>Please correct the following: </strong>
                    <span v-for="(error, index) in enrollment.errors" v-bind:key="error">{{error}}<span
                            v-if="(index+1) !== enrollment.errors.length">, </span></span>
                </div>
            </b-col>
        </b-row>
        <hr class="mt-5"/>
        <b-row class="mb-5">
            <b-col cols="6">
                <b-button variant="secondary" @click="$router.go(-1)">Cancel</b-button>
            </b-col>
            <b-col cols="6" class="text-right">
                <b-button variant="primary" @click="saveEnrollment()">Save Producer</b-button>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
    import axios from 'axios'
    import config from '@/config/config'

    export default {
        name: 'AddProducer',
        data: function () {
            return {
                enrollment: {
                    firstName: '',
                    lastName: '',
                    ssn: '',
                    npi: '',
                    dob: '',
                    verify: '',
                    password: '',
                    email: '',
                    complete: false,
                    errors: []
                }
            }
        },
        methods: {
            saveEnrollment: function () {
                this.enrollment.errors = []
                if(this.enrollment.password.length > 4) {
                    if (this.enrollment.password === this.enrollment.verify) {
                        if (this.enrollment.errors.length === 0) {
                            axios.post(config.apiUrl() + 'ga/save-producer', this.enrollment).then(response => {
                                if (response.data.msg === 'ok') {
                                    this.enrollment = {
                                        children: [],
                                        complete: true,
                                        errors: []
                                    }
                                    this.$router.push({
                                        path: 'dashboard/general-agent',
                                        params: {enrollId: response.id}
                                    })
                                } else {
                                    this.enrollment.errors.push(
                                        'An error occurred when saving your appointment. Please check it and try again.'
                                    )
                                }
                            }, err => {
                                this.enrollment.errors.push(
                                    'An error occurred when saving your appointment. Please check it and try again.'
                                )
                            })
                        }
                    } else {
                        this.enrollment.errors.push('The Passwords do not match.')
                    }
                } else {
                    this.enrollment.errors.push('Passwords need to be at least 5 letters.')
                }
            }
        }
    }
</script>

<style scoped>

</style>
